var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-checked d-flex align-items-center"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":function($event){return _vm.toggleChecked()}}}),_c('label',{staticClass:"ml-1 form-check-label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }